var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#353535"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6486 19.3514V8H21.7297V19.3514H12.6486ZM13.7837 18.2163H20.5946V9.13512H13.7837V18.2163ZM10 22V10.8815H11.1351V20.8649H18.8482V22H10Z",
    fill: "#E9E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCopyIcon);
export default __webpack_public_path__ + "static/media/chatCopyIcon.b7b660d847b792229fdc0b517c342c85.svg";
export { ForwardRef as ReactComponent };